import type { RoomPanelMetricInfo } from '../store/schema/RoomPanelMetricTypes';

export function createRoomPanelMetrics(): RoomPanelMetricInfo {
    const metrics: RoomPanelMetricInfo = {
        numOfCities: 0,
        numOfRoomlists: 0,
        totalNumSelectedCities: 0,
        totalNumSelectedRoomLists: 0,
        selectedFromSuggestion: false,
        selectedFromSearch: false,
        hasShowOnlyAvailableRoomsChanged: false,
        isFilterOpened: false,
        isFilterApplied: false,
        isCapacityFilterApplied: false,
        isFeatureFilterApplied: false,
        isFloorFilterApplied: false,
        isCapacityEnabled: false,
        isAudioEnabled: false,
        isDisplayEnabled: false,
        isVideoEnabled: false,
        isAccessibleEnabled: false,
        isFloorEnabled: false,
        queryStringChanged: false,
        isWorkspaceBookingEnabled: false,
    };

    return metrics;
}
